import React, { Component } from 'react';
import './Input.css';

class Input extends Component {
  state = {value: ''};
  handleChange = (event) => {
    this.setState({value: event.target.value});
  }
  render() {
    const {
      id: idInput = '0'
    } = this.props;

    return (
      <div className={`input ${this.props.modifier ? this.props.modifier : ''}`}>
        <textarea
          className="input__textarea"
          id={idInput}
          value={this.state.value}
          name={this.props.name}
          onChange={this.handleChange}
        />
        <label className="input__label" htmlFor={idInput}>{this.props.label}</label>
      </div>
    );
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/Textarea.js